import toolsRoute from '@/router/configuration/tools';
import levelTypesRoute from '@/router/configuration/types';
import presentsRoute from '@/router/configuration/presents';
import answerRoute from '@/router/configuration/answers';

const configurationRoute = {
	name: 'configuration',
	path: 'configuration',
	component: () => import('@/pages/configuration/page-configuration'),
	meta: {
		title: 'Configuración',
	},
	props: true,
	children: [
		{
			name: 'employees',
			path: 'employees',
			component: () => import('@/pages/configuration/employees'),
			meta: {
				title: 'Configuración',
			},
			children: [
				{
					name: 'present-assignment',
					path: 'presents/:employeeId',
					components: {
						presentAssignment: () => import('@/components/configuration/employees/assignmentPresents'),
					},
				},
			],
		},
		{
			name: 'areas',
			path: 'areas',
			component: () => import('@/pages/configuration/areas'),
			meta: {
				title: 'Configuración',
			},
		},
		levelTypesRoute,
		presentsRoute,
		toolsRoute,
		answerRoute,
	],
};
export default configurationRoute;



// WEBPACK FOOTER //
// ./src/router/configuration/index.js